<!-- @format -->

<ng-container *transloco="let t">
  <fudis-dialog [size]="'sm'">
    <fudis-heading [level]="2" fudisDialogTitle>{{ t("SIS_COMPONENTS.ACCESS_DENIED.REQUIRED_ACCESS_PERMISSIONS.TITLE") }}</fudis-heading>
    <fudis-dialog-content [contentFocus]="true">
      <fudis-body-text>{{ t("SIS_COMPONENTS.ACCESS_DENIED.REQUIRED_ACCESS_PERMISSIONS.DESCRIPTION") }}</fudis-body-text>
      <fudis-body-text>
        @for (name of localizedNames; track name; let last = $last) {
          <span class="fw-semibold">{{ name }}</span>
          @if (!last) {
            {{ t("SIS_COMPONENTS.ACCESS_DENIED.REQUIRED_ACCESS_PERMISSIONS.OR") }}
          }
        }
      </fudis-body-text>
    </fudis-dialog-content>
    <fudis-dialog-actions>
      <fudis-button fudisDialogClose [label]="t('SIS_COMPONENTS.BUTTON.CLOSE')" />
    </fudis-dialog-actions>
  </fudis-dialog>
</ng-container>
